import moment from 'moment';

export default timestamp =>
    timestamp && typeof timestamp === 'string'
        ? moment.utc(timestamp).format('MM/DD/YYYY')
        : typeof timestamp.toDate === 'function' && moment(timestamp.toDate()).calendar();
